module.exports = __webpack_public_path__ + "static/image/font/pc/bmhanna-1@3x.ver2_0_2.jpg?7145b9c9";